export const SLICES = {
  HUB_PREVIOUS: 'SLICES_HUB_PREVIOUS',
  HUB_NEXT: 'SLICES_HUB_NEXT',
  HUB_NO_RESULTS: 'SLICES_HUB_NO_RESULTS',
  INVESTORS_TABS_OTHER_THEMES: 'SLICES_INVESTORS_TABS_OTHER_THEMES',
  NOTATION_DOWNLOAD_LAST_REPORT: 'SLICES_NOTATION_DOWNLOAD_LAST_REPORT',
};
